import React from "react";
import { createRoot } from "react-dom/client";

class AppErrorBoundary extends React.Component<React.PropsWithChildren, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (this.state.failed) return <div className="screen-state"><div className="screen-state-mark">囍</div><strong>大屏启动遇到问题</strong><span>已加载资源不会被修改，请重新载入页面。</span><button onClick={() => window.location.reload()}>重新载入</button></div>;
    return this.props.children;
  }
}

const isScreen = window.location.pathname.startsWith("/screen");
const root = createRoot(document.getElementById("root")!);
if (isScreen) {
  import("./ScreenApp").then(({ ScreenApp }) => root.render(<React.StrictMode><AppErrorBoundary><ScreenApp /></AppErrorBoundary></React.StrictMode>));
} else {
  import("./AdminApp").then(({ AdminApp }) => root.render(<React.StrictMode><AdminApp /></React.StrictMode>));
}
